import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { PowerLimitationTableList } from '@store';
import { CustomTranslationsService } from 'src/app/operational-data-common/translations';

@Component({
  selector: 'app-power-limitation-history-list',
  templateUrl: './power-limitation-history-list.component.html',
  styleUrl: './power-limitation-history-list.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PowerLimitationHistoryListComponent {
  @Input() filteredData: PowerLimitationTableList[];
  @Input() isLoading: boolean;

  constructor(public customTranslationsService: CustomTranslationsService) {}
}
